import type { CSSProperties, Ref } from 'react';
import type { IRealChart } from '@/music/ireal/types';
import { prettyChordSymbol } from '@/music/ireal/chordParser';
import { ChordSymbol } from './chartChrome';

export function ReadingChartProbe({
  chart,
  probeRef,
  style,
}: {
  chart: IRealChart;
  probeRef: Ref<HTMLDivElement>;
  style: CSSProperties;
}) {
  return (
    <div
      ref={probeRef}
      className="reading-chart reading-chart-probe"
      style={style}
      aria-hidden="true"
    >
      {chart.measures.map((m) => (
        <div key={m.id}>
          {m.chords.map((c) => (
            <span key={c.id} className={`reading-probe-chord${c.small ? ' small' : ''}`}>
              <ChordSymbol reading symbol={c.symbol} className="sc-symbol" />
              {c.alternate && (
                <ChordSymbol reading symbol={prettyChordSymbol(c.alternate)} className="sc-alt" />
              )}
            </span>
          ))}
        </div>
      ))}
    </div>
  );
}
